const demoProfiles = [];
const demoUser = [];
const salesUser = [];
const demoListings = [];
const demoPopularLocations = [];
const demoSMTP = [];
const demoBlogPages = [];
const demoData = {};
const demoAdmin = {};

export {
    demoProfiles, demoUser, demoListings, demoPopularLocations, demoBlogPages, demoData, demoAdmin, salesUser, demoSMTP
}